import { PAGE_PATH } from '../../constants/config';

export const getPageLink = (builderId: number) => {
  return `${PAGE_PATH}/${builderId}/`;
};
